import React from "react";
import Lines from "./Tabs/Lines";
import Shifts from "./Tabs/Shifts";
import Tables from "./Tabs/Tables";
import Places from "./Tabs/Places";
import Products from "./Tabs/Products";
import Indicators from "./Tabs/Indicators";
import Card from "../../components/Card/Card.jsx";
import { db } from "../../services/firebase";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { Grid, Col, Row, Tab, Nav, NavItem, Breadcrumb } from "react-bootstrap";
import {
  faMapMarker,
  faExchangeAlt,
  faBars,
  faDolly,
  faChevronLeft,
  faPallet,
  faChartBar,
} from "@fortawesome/fontawesome-free-solid";

export default class CompanyProfile extends React.Component {
  state = { fetchingCompany: true, company: null };

  componentDidMount() {
    this._fetchCompany();
  }

  render() {
    return (
      <div className="main-content" style={{ padding: 0 }}>
        <Grid fluid>{this._handleContent()}</Grid>
      </div>
    );
  }

  //content handler
  _handleContent = () => {
    const { fetchingCompany, company } = this.state;

    if (fetchingCompany && !company) {
      return <h4>Buscando dados...</h4>;
    }

    if (!fetchingCompany && !company) {
      return this.props.history.push("/companies");
    }

    if (!fetchingCompany && company) {
      return (
        <div>
          <Breadcrumb style={{ padding: 0, marginBottom: 7, marginTop: 10 }}>
            <Breadcrumb.Item
              onClick={() => this.props.history.push("/companies")}
            >
              <FontAwesomeIcon icon={faChevronLeft} className="text-default" />{" "}
              <span className="text-default">Empresas</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="#" active>
              {company.name} ({company.city} - {company.state})
            </Breadcrumb.Item>
          </Breadcrumb>
          <Card
            title={company.name}
            category={
              <span>
                {company.city} - {company.state}
              </span>
            }
            content={
              <Tab.Container id="tabs-with-dropdown" defaultActiveKey="shifts">
                <Row className="clearfix">
                  <Col sm={12}>
                    <Nav bsStyle="tabs">
                      <NavItem eventKey="shifts">
                        <FontAwesomeIcon
                          icon={faExchangeAlt}
                          className="text-default"
                        />{" "}
                        <span style={{ color: "#444" }}>Turnos</span>
                      </NavItem>
                      <NavItem eventKey="places">
                        <FontAwesomeIcon
                          icon={faMapMarker}
                          className="text-default"
                        />{" "}
                        <span style={{ color: "#444" }}>Locais</span>
                      </NavItem>
                      <NavItem eventKey="lines">
                        <FontAwesomeIcon
                          icon={faBars}
                          className="text-default"
                        />{" "}
                        <span style={{ color: "#444" }}>Linhas</span>
                      </NavItem>
                      <NavItem eventKey="tables">
                        <FontAwesomeIcon
                          icon={faPallet}
                          className="text-default"
                        />{" "}
                        <span style={{ color: "#444" }}>Mesas</span>
                      </NavItem>
                      <NavItem eventKey="products">
                        <FontAwesomeIcon
                          icon={faDolly}
                          className="text-default"
                        />{" "}
                        <span style={{ color: "#444" }}>Produtos</span>
                      </NavItem>
                      <NavItem eventKey="indicators">
                        <FontAwesomeIcon
                          icon={faChartBar}
                          className="text-default"
                        />{" "}
                        <span style={{ color: "#444" }}>Indicadores</span>
                      </NavItem>
                    </Nav>
                  </Col>
                  <Col sm={12}>
                    <Tab.Content animation>
                      <Tab.Pane eventKey="shifts">
                        <Shifts companyID={this.props.match.params.companyID} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="places">
                        <Places companyID={this.props.match.params.companyID} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="lines">
                        <Lines companyID={this.props.match.params.companyID} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="tables">
                        <Tables companyID={this.props.match.params.companyID} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="products">
                        <Products
                          companyID={this.props.match.params.companyID}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="indicators">
                        <Indicators
                          companyID={this.props.match.params.companyID}
                        />
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            }
          />
        </div>
      );
    }
  };

  _fetchCompany = () => {
    const { companyID } = this.props.match.params;
    db.collection("companies")
      .doc(companyID)
      .onSnapshot((companySnapshot) => {
        if (!companySnapshot.exists) {
          this.setState({ fetchingCompany: false });
        } else {
          this.setState({
            fetchingCompany: false,
            company: companySnapshot.data(),
          });
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/views/Companies/CompanyProfile.jsx